import React, { useContext, useState, useEffect } from 'react';
import {
  auth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  updateEmail as updateFirebaseEmail,
  updatePassword as updateFirebasePassword,
  signInWithGoogle
} from '../util/firebase';

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Update the login function to use signInWithEmailAndPassword directly
  async function login(email, password) {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setCurrentUser(auth.currentUser);
      try {
        localStorage.setItem('rundoit_user', JSON.stringify(auth.currentUser));
      } catch (_) {}
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  }

  function signup(email, password) {
    return createUserWithEmailAndPassword(auth, email, password);
  }

  function logout() {
    return signOut(auth);
  }

  function resetPassword(email) {
    return sendPasswordResetEmail(auth, email);
  }

  function updateEmail(email) {
    if (currentUser) {
      return updateFirebaseEmail(currentUser, email);
    }
    throw new Error('No user logged in');
  }

  function updatePassword(password) {
    if (currentUser) {
      return updateFirebasePassword(currentUser, password);
    }
    throw new Error('No user logged in');
  }

  async function signInWithGoogleProvider() {
    try {
      const result = await signInWithGoogle();
      setCurrentUser(auth.currentUser);
      return result;
    } catch (error) {
      console.error('Google sign-in failed:', error);
      throw error;
    }
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      setCurrentUser(user);
      setLoading(false);
      try {
        if (user) {
          localStorage.setItem('rundoit_user', JSON.stringify(user));
        } else {
          localStorage.removeItem('rundoit_user');
        }
      } catch (_) {}
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    login,
    signup,
    logout,
    resetPassword,
    updateEmail,
    updatePassword,
    signInWithGoogleProvider
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
